import { executionToWorkflowDef } from "components/executionMapper";
import { useState, useEffect } from "react";
import { EdgeData, ElkRoot, NodeData } from "reaflow";
import { getDynamicForkJoinTasksList } from "./helpers";
import { workflowToNodeEdges } from "components/flow/nodes/mapper";

export const useWorkflowProcessor = (
  data: any,
  executionMode: boolean,
  subWorkflowFetcher?: () => Promise<any>
) => {
  const [nodes, setNodes] = useState<NodeData[]>();
  const [edges, setEdges] = useState<EdgeData[]>();

  useEffect(() => {
    const processWorkflow = async () => {
      try {
        let workflowDef;

        if (executionMode) {
          const [workflowDefinition, _executionStatusMap] =
            executionToWorkflowDef(data, getDynamicForkJoinTasksList(data));
          workflowDef = workflowDefinition;
        } else {
          workflowDef = data;
        }

        // Generate nodes and edges from the workflow
        const { nodes: generatedNodes, edges: generatedEdges } =
          await workflowToNodeEdges(
            workflowDef,
            true,
            true, // expand subworkflow
            subWorkflowFetcher ?? (async () => {}),
            // @ts-ignore
            {}
          );

        setNodes(generatedNodes);
        setEdges(generatedEdges);
      } catch (e) {
        console.error("Error processing workflow:", e);
      }
    };

    processWorkflow();
  }, [data, executionMode]);

  return { nodes: nodes ?? [], edges: edges ?? [] };
};
